<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0"
          v-text="'Reject shared item'"
        />
      </header>
      <textarea
        id="rejection-reason"
        v-model="rejectionReason"
        name="rejection-reason"
        cols="30"
        rows="10"
        placeholder="Add a comment for the sharing organization"
      />
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn--danger"
        @click.prevent="reject"
        v-text="'Reject'"
      />
      <button
        type="button"
        class="btn btn--border"
        @click="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'RejectSharedItemModal',
  data() {
    return {
      loading: false,
      rejectionReason: '',
    }
  },
  computed: {
    show() {
      return this.$store.state.document.rejectSharedItemModal.open
    },
    sharedItem() {
      return this.$store.state.document.rejectSharedItemModal.sharedItem
    },
  },
  methods: {
    reject() {
      this.loading = true

      this.$api.active().put(`shares/${this.sharedItem.uuid}/reject`, {
        rejection_reason: this.rejectionReason,
      })
        .then(() => {
          this.loading = false

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Shared item has been rejected.',
          })

          this.$emit('sharedItemHasBeenRejected')

          this.close()
        })
    },
    close() {
      this.rejectionReason = ''

      this.$store.commit('documentCloseRejectSharedItemModal')
    },
  },
}
</script>
